import Settings from '../settings';
import UserList from '../components/users/user-list';
import ExterUserList from '../components/users/external-users';
import InvoiceProjectList from '../components/identities/invoice-project-list';
import NoticesList from '../components/notices/notices-list';
import GeneralSettings from '../components/general/general-settings';
import BookingSettings from '../components/booking/booking-settings';
import AccountingSettings from '../components/accounting/accounting-settings';
import BillingSettings from '../components/billing/billing-settings';
import LabelSettings from '../components/label/label-settings';
import CustomTextSettings from '../components/custom-texts/custom-texts-settings';
import AISettings from '../components/ai/ai-settings';
import LanguageSettings from '../components/language/language-settings';
import SharingSettings from '../components/sharing/sharing-settings';
import PromotionSettings from '../components/promotion/promotion-settings';
import TaskSettings from '../components/task/task-settings.vue';
import { getDetailsTabRouteObjects } from '../../../utility/route';
import { userListLDTRoutes, identitiesLDTRoutes, noticesLDTRoutes ,externalUserListLDTRoutes} from './routes';


export default [
  {
    path: '/main/settings',
    name: 'settings',
    component: Settings,
    redirect: 'main/settings/users',
    children: [
      {
        name: 'settings_general',
        path: 'general',
        component: GeneralSettings
      },
      {
        name: 'settings_booking',
        path: 'booking/',
        component: BookingSettings
      },
      {
        name: 'settings_booking_tab',
        path: 'booking/:tab',
        component: BookingSettings
      },
      {
        name: 'submenu_tasks',
        path: 'task/',
        component: TaskSettings
      },
      // {
      //   name: 'submenu_tasks_tab',
      //   path: 'task/:tab',
      //   component: TaskSettings
      // },
      {
        name: 'settings_accounting',
        path: 'accounting/',
        component: AccountingSettings
      },
      {
        name: 'settings_accounting_tab',
        path: 'accounting/:tab',
        component: AccountingSettings
      },

      {
        name: 'billing',
        path: 'billing',
        component: BillingSettings
      },
      {
        name: 'settings_label',
        path: 'label',
        component: LabelSettings
      },
      {
        name: 'settings_label_tab',
        path: 'label/:tab',
        component: LabelSettings
      },
      
      {
        name: 'settings_custom_texts',
        path: 'custom_texts',
        component: CustomTextSettings
      },
      {
        name: 'settings_custom_texts_tab',
        path: 'custom_texts/:tab',
        component: CustomTextSettings
      },
      {
        name: 'settings_ai',
        path: 'ai',
        component: AISettings
      },
      {
        name: 'settings_ai_tab',
        path: 'ai/:tab',
        component: AISettings
      },
      {
        name: 'settings_language',
        path: 'language',
        component: LanguageSettings
      },
      {
        name:'sharing',
        path:'sharing',
        component:SharingSettings

      },
      {
        name:'promotion',
        path:'promotion',
        component:PromotionSettings

      },
      ...getDetailsTabRouteObjects(identitiesLDTRoutes, InvoiceProjectList),
      ...getDetailsTabRouteObjects(userListLDTRoutes, UserList),
      ...getDetailsTabRouteObjects(externalUserListLDTRoutes, ExterUserList),
      ...getDetailsTabRouteObjects(noticesLDTRoutes, NoticesList),
    ]
  }
]
